module.exports = __webpack_public_path__ + "media/images/logo--primary-a1bd1f142bde797d416ed759272fb1e2.svg";